import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import videojs from 'video.js';

import FuelVideo from '@/components/fuel-video';

import { useModalContext } from '../VNModalProvider';
import VnModalBody from './VnModalBody';
import VnModalFooter from './VnModalFooter';

const defaultVideoJsOptions = {
  autoplay: true,
  controls: true,
  responsive: true,
  fluid: true,
  sources: [
    {
      src: null,
      type: 'video/mp4',
    },
  ],
};

const ChannelPreviewModal = ({ channel, videoJsOptions }) => {
  const playerRef = React.useRef(null);
  // const [videoJsOptions, setVideoJsOptions] = useState(_.cloneDeep(defaultVideoJsOptions));
  const { onClose } = useModalContext();

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on('waiting', () => {
      videojs.log('player is waiting');
    });

    player.on('dispose', () => {
      videojs.log('player will dispose');
    });
  };

  // useEffect(() => {
  //   if (channel) {
  //     const myVideoJSOptions = _.cloneDeep(defaultVideoJsOptions);
  //     myVideoJSOptions.sources = [
  //       {
  //         src: channel?.url,
  //         type: 'application/x-mpegURL',
  //       },
  //     ];
  //     console.log(myVideoJSOptions);
  //     setVideoJsOptions(myVideoJSOptions);
  //   }
  // }, [channel]);

  return (
    <>
      <VnModalBody>
        <Box>{channel && <FuelVideo options={videoJsOptions} onReady={handlePlayerReady} />}</Box>
        <Box sx={{ marginTop: 1 }}>
          <Typography sx={{ fontWeight: 700 }}>Note:</Typography>
          <Box>
            New videos added to a channel need a few minutes to complete conforming before they are available for playout. Check
            the status of the videos in the content screen of the channel to make sure at least one is in a 'Ready' state.
          </Box>
        </Box>
      </VnModalBody>
      <VnModalFooter
        right={
          <Button autoFocus variant="contained" className="cancel-button" onClick={onClose}>
            Close
          </Button>
        }
      />
    </>
  );
};

export default ChannelPreviewModal;
